import {
  ResponsesStatementDetailsDirectTreasuryResponse,
  ResponsesTitlesResponse,
} from '@genial/services/dist/models';
import { Utils } from '@genial/utils';

import { validateAndFormatValue, messageError } from '../../Table/constants';

export const parseMainData = (data: ResponsesTitlesResponse) => {
  const maturityDate = data?.maturityDate
    ? Utils.Mask.DateFormat(data?.maturityDate, 'dd/MM/yyyy')
    : messageError;

  const previousBalance =
    data?.previousBalance || data?.previousBalance === 0 ? data?.previousBalance : messageError;
  const baseValue = validateAndFormatValue(data?.baseValue, 'money');
  const feeDue = validateAndFormatValue(data?.feeDue, 'money');
  const blockedQuantity =
    data?.blockedQuantity || data?.blockedQuantity === 0 ? data?.blockedQuantity : messageError;
  const creditQuantity =
    data?.creditQuantity || data?.creditQuantity === 0 ? data?.creditQuantity : messageError;
  const debitQuantity =
    data?.debitQuantity || data?.debitQuantity === 0 ? data?.debitQuantity : messageError;

  const item = [
    { label: 'Vencimento', value: maturityDate },
    { label: 'Valor unitário', value: baseValue },
    { label: 'Saldo anterior', value: previousBalance },
    { label: 'Qtd. bloqueada', value: blockedQuantity },
    { label: 'Qtd. crédito', value: creditQuantity },
    { label: 'Qtd. débito', value: debitQuantity },
    { label: 'Qtd. atual', value: data?.actualBalance || messageError },
    { label: 'Taxa devida', value: feeDue },
  ];

  return item;
};

export const parseDirectTreasuryDetailsData = (
  data: ResponsesStatementDetailsDirectTreasuryResponse[]
) => {
  const details = data?.map((detail, index) => {
    const iofValue = validateAndFormatValue(detail?.detailDirectTreasury?.iofValue, 'money');
    const irValue = validateAndFormatValue(detail?.detailDirectTreasury?.irValue, 'money');
    const cblcCustodyFee = validateAndFormatValue(
      detail?.detailDirectTreasury?.cblcCustodyFee,
      'money'
    );
    const custodyFeeBroker = validateAndFormatValue(
      detail?.detailDirectTreasury?.custodyFeeBroker,
      'money'
    );
    const profitabilityMonth = validateAndFormatValue(
      detail?.detailDirectTreasury?.profitabilityMonth,
      'percentage'
    );
    const profitabilityYear = validateAndFormatValue(
      detail?.detailDirectTreasury?.profitabilityYear,
      'percentage'
    );
    const profitabilityTwelveMonths = validateAndFormatValue(
      detail?.detailDirectTreasury?.profitabilityTwelveMonths,
      'percentage'
    );
    const netValue = validateAndFormatValue(detail?.detailDirectTreasury?.netValue, 'money');
    const purchaseDate = validateAndFormatValue(detail?.detailDirectTreasury?.purchaseDate, 'date');
    const actualBalance =
      detail?.detailDirectTreasury?.actualBalance ||
      detail?.detailDirectTreasury?.actualBalance === 0
        ? detail?.detailDirectTreasury?.actualBalance
        : messageError;
    const purchasePrice = validateAndFormatValue(
      detail?.detailDirectTreasury?.purchasePrice,
      'money'
    );
    const investedValue =
      (detail?.detailDirectTreasury?.actualBalance ||
        detail?.detailDirectTreasury?.actualBalance === 0) &&
      (detail?.detailDirectTreasury?.purchasePrice ||
        detail?.detailDirectTreasury?.purchasePrice === 0)
        ? validateAndFormatValue(
            detail?.detailDirectTreasury?.actualBalance *
              detail?.detailDirectTreasury?.purchasePrice,
            'money'
          )
        : messageError;
    const agreedRate = validateAndFormatValue(
      detail?.detailDirectTreasury?.agreedRate,
      'percentage'
    );
    const grossValue = validateAndFormatValue(detail?.detailDirectTreasury?.grossValue, 'money');
    const accumulatedProfitability = validateAndFormatValue(
      detail?.detailDirectTreasury?.accumulatedProfitability,
      'percentage'
    );
    const calendarDays = detail?.detailDirectTreasury?.calendarDays || messageError;
    const irTaxRate = validateAndFormatValue(detail?.detailDirectTreasury?.irTaxRate, 'percentage');

    return {
      // Todas as compras do título compartilham o titleId; o índice garante key única no FlatList
      titleId: `details-${detail?.detailDirectTreasury?.titleId}-${index}`,
      iofValue,
      irValue,
      cblcCustodyFee,
      custodyFeeBroker,
      profitabilityMonth,
      profitabilityYear,
      profitabilityTwelveMonths,
      netValue,
      purchaseDate,
      actualBalance, // Quantidade
      purchasePrice,
      investedValue,
      agreedRate,
      grossValue,
      accumulatedProfitability,
      calendarDays,
      irTaxRate,
    };
  });

  return details;
};
